import type { BusEvents } from './types';

type Handler<T> = (payload: T) => void;

export interface Bus {
  on<K extends keyof BusEvents>(event: K, handler: Handler<BusEvents[K]>): () => void;
  emit<K extends keyof BusEvents>(event: K, payload: BusEvents[K]): void;
}

export function createBus(): Bus {
  const handlers = new Map<keyof BusEvents, Set<Handler<any>>>();
  return {
    on(event, handler) {
      let set = handlers.get(event);
      if (!set) { set = new Set(); handlers.set(event, set); }
      set.add(handler);
      return () => { set!.delete(handler); };
    },
    emit(event, payload) {
      const set = handlers.get(event);
      if (!set) return;
      for (const h of set) {
        try { h(payload); } catch (err) { console.error(`[bus:${String(event)}]`, err); }
      }
    },
  };
}
